<script>
import CartAPI from "../../classes/API/CartAPI.js";
import bus from 'vue3-eventbus';
import Price from "../Price.vue";
import {useModal} from 'vue-final-modal'
import Modal from "$vueCommon/components/Modal.vue";
import DomainItemContact from "./DomainItemContact.vue";
import DomainItemDnsProfile from '$vueCommon/components/Cart/DomainItemDnsProfile.vue';
import frontendImgCartContact from '$frontend/img/cart-contact.svg';
import frontendImgCartPerson from '$frontend/img/cart-person.svg';
import frontendImgCartDnsServer from '$frontend/img/cart-dns-server.svg';
import frontendImgCartCloud from '$frontend/img/cart-cloud.svg';
import CheckoutAPI from '$vueCommon/classes/API/CheckoutAPI.js';
import DomainIdProtectConfirm from "$vueCommon/components/Cart/DomainIdProtectConfirm.vue";

export default {
    components: {
        Price
    },
    emits: ['onIdentitySelected'],
    props: {
        domain: Object,
        identities: Array,
        dnsProfiles: Array,
        source: String,
        isSaving: Boolean
    },
    mounted() {
        if (!this.domain.options) {
            this.domain.options = {};
        }

        this.setPeriods();
        this.populateData();
        this.showDetails = false;
        bus.on('showDetails', (rowIdToOpen) => {
            if (!this.domain) {
                return false;
            }

            if (rowIdToOpen === this.domain.rowId) {
                this.showDetails = true;
            }
        });
        document.addEventListener('click', this.onDocumentClick);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.onDocumentClick);
    },
    updated() {
        this.populateData();
    },
    data() {
        return {
            periods: [],
            domainPeriod: null,
            idProtect: false,
            disabled: false,
            isIdProtectLoading: false,
            isPeriodLoading: false,
            isDeleting: false,
            openDropdown: false,
            isCollapsing: false,
            frontendImgCartContact,
            frontendImgCartPerson,
            frontendImgCartDnsServer,
            frontendImgCartCloud,
            api: this.source === 'Cart' ? CartAPI : CheckoutAPI,
            showDetails: false
        }
    },
    methods: {
        populateData() {
            this.domainPeriod = this.periods.find(period => period.value === this.domain.period);
            if (!this.domainPeriod) {
                this.domainPeriod = this.periods[0];
            }

            this.idProtect = this.domain.options ? this.domain.options.idProtect : false;
        },
        setPeriods() {
            const minimalPeriod = this.domain.minimalPeriod ? this.domain.minimalPeriod : 1;

            this.periods = [];
            for (let period = minimalPeriod; period <= 10; period += minimalPeriod) {
                this.periods.push({
                    label: this.$translate('checkout.' + period + '_year' + (period > 1 ? 's' : '')),
                    value: period
                });
            }
        },
        setSelected(v) {
        },
        deleteDomain() {
            this.isDeleting = true;
            this.api.remove(this.domain.rowId).then(response => {
                this.isDeleting = false;
            })
        },
        togglePeriodDropdown(e) {
            if (!this.domain.canChangePeriod) {
                return;
            }

            const select = this.$refs.periodSelect;
            if (!select) {
                return;
            }

            select.toggleDropdown(e);
        },
        onDocumentClick(e) {
            const selectComponent = this.$refs.periodSelect;
            if (!selectComponent) {
                return;
            }

            if (!selectComponent.open) {
                return;
            }

            const selectEl = selectComponent.$el;
            const containerEl = this.$refs.periodContainer;

            if (selectEl && selectEl.contains(e.target)) {
                return;
            }

            if (containerEl && containerEl.contains(e.target)) {
                return;
            }

            selectComponent.open = false;
        },
        idProtectToggle(confirmed = false) {
            if (this.domain.options.idProtect === true && !confirmed) {
                this.confirmIdProtectToggle(() => {
                    this.idProtectToggle(true);
                });
            } else {
                this.isIdProtectLoading = true;
                this.api.idProtect(this.domain.rowId, !(this.domain.options.idProtect && this.domain.options.idProtect === true)).then(() => {
                    this.isIdProtectLoading = false;
                });
            }
        },
        editDomainContact() {
            let domain = this.domain;
            let identities = this.identities;
            let selectedIdentityId = this.domain.options.registrant_user_identity_id;
            const {open, close} = useModal({
                reserveScrollBarGap: true,
                component: Modal,
                attrs: {
                    title: this.$translate('checkout.domain_registrant_data', {domain: domain.name}),
                    size: 'lg',
                    class: 'allow-overflow',
                    onConfirm() {
                        close();
                    },
                },
                slots: {
                    default: {
                        component: DomainItemContact,
                        attrs: {
                            domain: domain,
                            identities: identities,
                            selectedIdentityId: selectedIdentityId,
                            onDismiss: function () {
                                close();
                            },
                            onConfirm: function (domainContactEvent) {
                                bus.emit('domainIdentitySelected', {
                                    ...domainContactEvent,
                                    rowId: domain.rowId
                                });
                                close();
                            }
                        }
                    }
                },
            });
            open();
        },
        editDnsProfile() {
            let domain = this.domain;
            let dnsProfiles = this.dnsProfiles;
            let selectedDnsProfileId = this.domain.options.user_dns_profile_id;
            const {open, close} = useModal({
                component: Modal,
                attrs: {
                    title: this.$translate('checkout.edit_dns_profile') + ': ' + domain.name,
                    size: 'lg',
                    class: 'allow-overflow',
                    onConfirm() {
                        close();
                    },
                },
                slots: {
                    default: {
                        component: DomainItemDnsProfile,
                        attrs: {
                            domain: domain,
                            dnsProfiles: dnsProfiles,
                            selectedDnsProfileId: selectedDnsProfileId,
                            onDismiss: function () {
                                close();
                            },
                            onConfirm: function (domainDnsProfileEvent) {
                                bus.emit('domainDnsProfileSelected', {
                                    ...domainDnsProfileEvent,
                                    rowId: domain.rowId
                                });
                                close();
                            }
                        }
                    }
                },
            });
            open();
        },
        confirmIdProtectToggle(onConfirm) {
            let domain = this.domain;
            const {open, close} = useModal({
                component: Modal,
                attrs: {
                    title: this.$translate('checkout.confirmation'),
                    size: 'md',
                    onConfirm() {
                        close();
                    },
                },
                slots: {
                    default: {
                        component: DomainIdProtectConfirm,
                        attrs: {
                            domain: domain,
                            onDismiss: function () {
                                close();
                            },
                            onConfirm: function () {
                                onConfirm();
                                close();
                            }
                        }
                    }
                },
            });
            open();
        },
        getSelectedIdentity() {
            for (let identity of this.identities) {
                if (identity.id === this.domain.options.registrant_user_identity_id) {
                    return identity;
                }
            }
            return false;
        },
        getSelectedDnsProfile() {
            for (let dnsProfile of this.dnsProfiles) {
                if (dnsProfile.id === this.domain.options.user_dns_profile_id) {
                    return dnsProfile;
                }
            }
        },
        dropdownShouldOpen() {
            return this.openDropdown;
        },
        toggleDetails() {
            this.isCollapsing = true;
            setTimeout(() => {
                this.isCollapsing = false;
            }, 5500)
            this.showDetails = !this.showDetails;
        },
        restrictionsAcceptedChanged() {
            bus.emit('restrictionsAcceptedChanged', this.domain);
        }
    },
    watch: {
        domainPeriod: function (n, o) {
            if (this.domain.associate === 'DomainTrade' || this.domain.associate === 'IdProtect') {
                return;
            }
            if (!n) {
                return;
            }
            if (this.domain.period === n.value) {
                return;
            }
            this.isPeriodLoading = true;
            this.openDropdown = false;
            this.api.period(this.domain.rowId, n.value).then(() => {
                this.isPeriodLoading = false;
            });
        }
    },
    computed: {
        selectedIdentity() {
            return this.getSelectedIdentity()
        },
        selectedDnsProfile() {
            return this.getSelectedDnsProfile();
        },
        isLoading() {
            return this.isIdProtectLoading || this.isPeriodLoading || this.isDeleting;
        },
        domainPeriodYear() {
            if (typeof (this.domainPeriod) === 'object' && this.domainPeriod !== null) {
                return 'checkout.' + this.domainPeriod.value + '_year' + (this.domainPeriod.value > 1 ? 's' : '');
            }
            return '';
        },
        displayDomainOptions() {
            return this.domain.associate !== 'DomainTrade' && this.domain.associate !== 'IdProtect';
        }
    }
}
</script>
<template>
    <div class="card cart-item cart-item-domain" :rid="domain.rowId"
         :class="{'loading': isSaving, 'hide-details': !showDetails, 'is-collapsing': isCollapsing,
         'is-premium': domain.options.premium}"
         @mouseleave="openDropdown = false">
        <div class="card-body">
            <div class="row align-items-center" @click="toggleDetails">
                <div class="col-8 d-flex align-items-center">
                    <div
                        class="cart-item-icon"
                        v-if="!isDeleting && !isSaving && !domain.options.premium"
                    ></div>
                    <div
                        class="cart-item-icon"
                        v-if="!isDeleting && !isSaving && domain.options.premium"
                        v-tippy="$translate('checkout.premium_domain_warning')"
                    ></div>
                    <div class="cart-item-loader" v-if="isDeleting || isSaving"></div>
                    <h3 class="mb-0">
                        {{ domain.name }}
                    </h3>
                </div>
                <div class="col-4 text-end d-flex align-items-center justify-content-end">
                    <h3 class="mb-0">
                        <Price :price="domain.price" :promo-price="domain.promoPrice"></Price>
                    </h3>
                    <div class="collapse-switch d-lg-none">
                        <i class="fa fa-chevron-up"></i>
                    </div>
                </div>
            </div>
            <div class="domain-collapse-wrapper">
                <div class="domain-collapse">
                    <div class="domain-options mt-3" v-if="displayDomainOptions" :class="{'no-id-protect': !domain.idProtectAvailability}">
                        <div class="domain-option-registration"
                             ref="periodContainer"
                             @click="togglePeriodDropdown($event)"
                             :class="{'can-change':domain.canChangePeriod}">
                            <div>
                                <div class="cart-icon"></div>
                                {{ $translate('checkout.registration_period') }}
                            </div>
                            <div>
                                <vselect
                                    v-if="domain.canChangePeriod"
                                    ref="periodSelect"
                                    :options="periods"
                                    v-model="domainPeriod"
                                    :clearable="false"
                                    :searchable="false"
                                    :transition="'none'"
                                >
                                    <template v-if="isPeriodLoading" v-slot:selected-option="option">
                                        <span class="vue-loader-dark"></span>
                                    </template>
                                </vselect>

                                <span v-if="!domain.canChangePeriod">
                                    {{ $translate(domainPeriodYear) }}
                                </span>
                            </div>
                        </div>
                        <div v-if="domain.idProtectAvailability" class="pretty p-switch domain-option-id-protect"
                             v-tippy="$translate('checkout.id_protect_tippy')">
                            <template v-if="!isIdProtectLoading">
                                <input type="checkbox" v-model="idProtect" @change="idProtectToggle()">
                                <div class="state">
                                    <label>
                                        <span class="cart-icon"></span> <span>{{ $translate('checkout.id_protect')
                                        }}</span>
                                    </label>
                                </div>
                            </template>
                            <template v-if="isIdProtectLoading" class="domain-option-id-protect">
                                <label class="mb-0">
                                    <span class="cart-icon"></span> <span>{{ $translate('checkout.id_protect') }}</span>
                                    <span class="loader">
                                <span class="vue-loader-dark"></span>
                            </span>
                                </label>
                            </template>
                        </div>
                        <div v-if="!domain.idProtectAvailability"
                             class="pretty p-switch domain-option-id-protect domain-option-id-protect-empty"></div>
                    </div>
                    <template v-if="source === 'Checkout' && domain.associate === 'Domain'">
                        <div class="domain-contacts mt-3 cursor-pointer" @click="editDomainContact()"
                             :class="{'is-invalid': domain.errors && (domain.errors.registrant_data)}">
                            <div>
                                <div class="ico me-2">
                                    <img :src="frontendImgCartContact" width="20" height="20">
                                </div>
                                <div class="name">{{ $translate('checkout.registrant_data') }}</div>
                                <div class="ico ms-md-3 me-md-1">
                                    <img v-if="selectedIdentity" :src="frontendImgCartPerson" width="15" height="15">
                                </div>
                                <div class="contact">
                                    <template v-if="selectedIdentity">
                                        <strong v-if="!(selectedIdentity.address && selectedIdentity.city)">
                                            <span v-if="!(!!selectedIdentity.company_name && selectedIdentity.company_name.trim().length > 0)">{{ selectedIdentity.first_name }} {{ selectedIdentity.last_name }}</span>
                                            <span v-if="(!!selectedIdentity.company_name && selectedIdentity.company_name.trim().length > 0)">{{ selectedIdentity.company_name }}</span>
                                        </strong>
                                        <strong v-if="selectedIdentity.address && selectedIdentity.city">
                                            <span v-if="!(!!selectedIdentity.company_name && selectedIdentity.company_name.trim().length > 0)">{{ selectedIdentity.first_name }} {{ selectedIdentity.last_name }},</span>
                                            <span v-if="(!!selectedIdentity.company_name && selectedIdentity.company_name.trim().length > 0)">{{ selectedIdentity.company_name }},</span>
                                            {{ selectedIdentity.address }} {{ selectedIdentity.address2 }},
                                            {{ selectedIdentity.postal_code }} {{ selectedIdentity.city }}
                                        </strong>
                                    </template>
                                </div>
                                <button class="btn btn-secondary btn-sm">
                                    {{ $translate('checkout.edit') }}
                                </button>
                            </div>
                        </div>
                        <div v-if="domain.errors && domain.errors.registrant_data" class="invalid-feedback">
                            <div v-for="error of domain.errors.registrant_data"><small>{{ error }}</small></div>
                        </div>
                        <div class="domain-dns mt-3 cursor-pointer"
                             :class="{'is-invalid': domain.errors && domain.errors.dns}"
                             @click="editDnsProfile()">
                            <div>
                                <div class="ico me-2">
                                    <img :src="frontendImgCartDnsServer" width="20" height="20">
                                </div>
                                <div class="name">{{ $translate('checkout.dns_profile') }}</div>
                                <div class="ico ms-md-3 me-md-1" v-if="selectedDnsProfile">
                                    <img :src="frontendImgCartCloud" width="15" height="15">
                                </div>
                                <div class="contact" v-if="selectedDnsProfile">
                                    <strong>{{ selectedDnsProfile.name }} ({{ selectedDnsProfile.dns_1 }},
                                        {{ selectedDnsProfile.dns_2 }})</strong>
                                </div>
                                <button class="btn btn-secondary btn-sm">
                                    {{ $translate('checkout.edit') }}
                                </button>
                            </div>
                        </div>
                        <div v-if="domain.errors && domain.errors.dns" class="invalid-feedback">
                            <small>{{ domain.errors.dns }}</small>&nbsp;
                        </div>
                    </template>
                    <button @click="deleteDomain" class="domain-delete" v-if="domain.canDelete">
                        <span></span> {{ $translate('checkout.remove') }}
                    </button>
                    <div class="alert mt-2 mb-0 p-2" style="font-size: 0.85rem;"
                         v-if="domain.registrationInfo"
                         :class="{'alert-warning': !domain.options.restrictions_accepted, 'alert-light': domain.options.restrictions_accepted}">
                        {{ domain.registrationInfo }}<br/>
                        <a
                            :href="'/domain-database/' + domain.extension"
                            target="_blank">
                            {{ $translate('common.read_more') }}
                        </a>
                    </div>
                    <div class="alert mt-2 mb-0 p-2" style="font-size: 0.85rem;"
                         v-if="domain.restrictions && !domain.registrationInfo"
                        :class="{'alert-warning': !domain.options.restrictions_accepted, 'alert-light': domain.options.restrictions_accepted}">
                        {{ $translate('checkout.restrictions_warning') }}<br/>
                        <a
                            :href="'/domain-database/' + domain.extension"
                            target="_blank">
                            {{ $translate('common.read_more') }}
                        </a>
                    </div>
                    <template v-if="source === 'Checkout'">
                        <div
                            class="form-check mt-2 mb-0"
                            style="font-size: 0.85rem;"
                            v-if="source === 'Checkout' && (domain.restrictions || domain.registrationInfo)"
                            :class="{'is-invalid': domain.errors && domain.errors.restrictions}"
                        >
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :id="'restrictions-' + domain.rowId"
                                v-model="domain.options.restrictions_accepted"
                                @change="restrictionsAcceptedChanged()"
                            />
                            <label class="form-check-label" :for="'restrictions-' + domain.rowId">
                                {{ $translate('checkout.information_regarding_registration_restrictions_for_domain_checkbox') }}
                            </label>
                        </div>
                        <div
                            v-if="source === 'Checkout' && domain.errors && domain.errors.restrictions"
                            class="invalid-feedback d-block"
                        >
                            <small>{{ domain.errors.restrictions }}</small>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
